import React, { useState, useEffect } from 'react';
import MainTable from '../../../components/Table/PaginationTable.js';
import { useNavigate } from 'react-router-dom';
import { ColumnDefShipmentOutbox } from '../columns/ColumnDefShipment.js';
import { useSelector, useDispatch } from 'react-redux';
import {
  fetchShipments, deleteShipmentById, resetShipmentState, validateShipmentStockLot, placeShipment,
  validateShipmentLotExistence, generateShipmentAutoOrder
} from '../../../redux/shipmentSlice.js';
import DeclineShipmentModalComponent from "../../../components/Modals/DeclineShipmentModalComponent";
import RejectReasonShipmentModalComponent from "../../../components/Modals/RejectReasonShipmentModalComponent.js"
import WarningShipmentModalComponent from "../../../components/Modals/WarningShipmentModalComponent.js"
import { ACTION, SHIPMENT } from '../../../helpers/commonName.js';
import FilterPanelShipment from '../../../components/common components/FilterPanelShipment.js';
import { getDate } from '../../../helpers/helperFunction.js'
import ControlPointOutlinedIcon from '@mui/icons-material/ControlPointOutlined';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import FileOutlineIcon from '@mui/icons-material/Description';
import { Menu, MenuItem, Button } from '@mui/material';
import DownloadButton from '../../../components/common components/DownloadButton.js';
import AddLotForProductWarningModal from '../../../components/Modals/AddLotForProductWarningModal.js';
import AlertShipmentModal from '../../../components/Modals/AlertShipmentModal.js';
import PoNotFoundModal from '../../../components/Modals/PoNotFoundModal.js';

const ShipmentOutboxComponent = () => {
  const dispatch = useDispatch();
  // const { data, loading, error } = useState(''); // Assuming the state shape
  const [actionType, setActionType] = useState('');
  const [shipmentId, setShipmentId] = useState(null);
  const [isLinked, setIsLinked] = useState(0)
  const tableData = useSelector(state => state.shipment.shipmentData)// console.log("****",state.order.data
  // const isLoading = useSelector(state => state.shipment.loading);
  // const isError = useSelector(state => state.shipment.error);
  const token = useSelector((state) => state.auth.token);
  const totalRecords = useSelector(state => state.shipment?.totalRecords) || 0;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  // console.log("totalRecords",totalRecords);


  // const { data, loading, error } = useSelector((state) => state.tableData); // Assuming the state shape
  const [filters, setFilters] = useState({
    search: '',
    fromDate: '',
    toDate: '',
    shipmentStatus: ''
  });
  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false); // State to manage filter panel visibility
  const [isReasonModalOpen, setIsReasonModalOpen] = useState(false);
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [pageNumber, setPageNumber] = useState(1); //  1-based indexing
  const [pageSize, setPageSize] = useState(10);
  const [isShipmentAlertModalOpen, setIsShipmentAlertModalOpen] = useState(false);
  const [isValidateLotModalOpen, setIsValidateLotModalOpen] = useState(false);
  const [isPoNotFoundModalOpen, setIsPoNotFoundModalOpen] = useState(false);
  const [message, setMessage] = useState(null);
  const navigate = useNavigate();

  const onPageIndexChange = (newPageIndex) => {
    // console.log("newPageIndex",newPageIndex);
    setPageNumber(newPageIndex);
  };

  const onPageSizeChange = (newPageSize) => {
    // console.log("newPageSize",newPageSize);
    setPageSize(newPageSize);
    setPageNumber(1); // Reset to the first page when page size changes
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // Function to handle filter action
  const handleFilter = (filters) => {
    // console.log(filters,"filters")
    setFilters(filters);
    const queryParams = {
      type: 'outgoing',
      searchText: filters.search || '',
      fromDate: filters.fromDate || '',
      toDate: filters.toDate || '',
      shipmentStatus: filters.shipmentStatus || '',
      pageSize,
      pageNumber,
    };
    dispatch(fetchShipments(queryParams));
  };

  // Function to handle reset action
  const handleReset = () => {
    setFilters({
      search: '',
      fromDate: '',
      toDate: ''
    });
    const queryParams = {
      type: 'outgoing',
      searchText: '',
      fromDate: '',
      toDate: '',
      shipmentStatus: '',
      pageSize,
      pageNumber,
    };
    // Perform reset logic
    dispatch(fetchShipments(queryParams))
    // console.log('Filter criteria reset');
  };

  useEffect(() => {
    // console.log(`Fetching with pageSize: ${pageSize}, pageNumber: ${pageNumber},${token}`);
    dispatch(resetShipmentState());
    const queryParams = {
      type: 'outgoing',
      searchText: filters.search || '',
      fromDate: filters.fromDate || '',
      toDate: filters.toDate || '',
      shipmentStatus: filters.shipmentStatus || '',
      pageSize,
      pageNumber,
    };
    dispatch(fetchShipments(queryParams));
  }, [dispatch, pageSize, pageNumber]);


  const handleAction = (shipment, action) => {
    const shipmentId = shipment.shipmentId;
    setActionType(action);
    setShipmentId(shipmentId);
    switch (action) {
      case ACTION.VIEW:
        navigate(`/view-details-outbox/${shipmentId}`);
        break;
      case ACTION.EDIT:
        navigate(`/edit-shipment`, { state: { actionType: 'edit', shipmentId: shipmentId } });
        break;
      case ACTION.DELETE:
        // console.log("Shipment deleted successfully");
        setIsDeleteModalOpen(true);
        break;
      case ACTION.PLACE:
        setIsLinked(shipment.islinked)
        handlePlaceShipmentIconClick(shipment);
        break;
      case SHIPMENT.CANCEL_SHIPMENT:
        setIsCancelModalOpen(true);
    }
    // navigate(`/view-details-outbox/${shipmentId}`); // Replace with your desired path
  };

  const onValidateLotModalClose = () => {
    setIsValidateLotModalOpen(false);
  }

  const onShipmentAlertModalClose = () => {
    setIsShipmentAlertModalOpen(false)
  }

  const onPoNotFoundModalClose = () => {
    setIsPoNotFoundModalOpen(false)
  }

  const linkAutoGeneratedOrder = () => {
    try {
      dispatch(generateShipmentAutoOrder({ shipmentId, orderNumber: '', type: "auto-generate" }))
        .then((response) => {
          // console.log("responseeeeeeeeee",response);
          if (response.type === 'shipment/generateShipmentAutoOrder/fulfilled') {
            dispatch(placeShipment({
              shipmentId: shipmentId,
              action: 'placeShipment'
            })).then((response) => {
              if (response.type === 'shipment/placeShipment/fulfilled') {
                const queryParams = {
                  type: 'outgoing',
                  searchText: filters.search || '',
                  fromDate: filters.fromDate || '',
                  toDate: filters.toDate || '',
                  shipmentStatus: filters.shipmentStatus || '',
                  pageSize,
                  pageNumber,
                };
                dispatch(fetchShipments(queryParams));
              }
            });
          }
        })
      setIsPoNotFoundModalOpen(false)
      // dispatch(generateShipmentAutoOrder({shipmentId, orderNumber:''}))
    }
    catch(err){
      // console.log("")
      toast.error("Something went wrong!")
    }
  }

  const handlePlaceShipmentIconClick = async (shipment) => {
    console.log("SHIPPMENTT", shipment);
    const shipmentId = shipment.shipmentId;
    // const response = await validateShipmentStockLot(shipmentId, 'validateStock') // API doesn't seems to be working
    //   console.log("validateShipmentStockLot response",response);
    let place = true;
    //     const productCount = shipment.shipmentProducts.length;
    // if (productCount === 0) {
    //   setMessage("Please Add atleast one product to proceed");
    //   place = false;
    //   setIsValidateLotModalOpen(true)
    // } else {
    const response = await validateShipmentLotExistence(shipmentId, 'checkLotExists');
    // console.log("response",response);
    if (response === 0) {
      place = false;
      setMessage("Please Add Lot to proceed");
      setIsValidateLotModalOpen(true)
    } else if (response === -1) {
      place = false;
      setMessage("Are you sure you don't want to add lot for all products? Please delete those products for which you don't want to add lot.");
      setIsValidateLotModalOpen(true)
    }
    // }
    if (place) {
      setIsShipmentAlertModalOpen(true);
    }
  }

  const handlePlaceShipment = () => {
    setIsShipmentAlertModalOpen(false);
    if (isLinked) {
      dispatch(placeShipment({
        shipmentId: shipmentId,
        action: 'placeShipment'
      })).then(() => {
        navigate('/outbox-shipment');
      });
    } else {
      // console.log("INSIDE ELSE OF HANDLE PLACE SHIPMENT")
      setIsPoNotFoundModalOpen(true);
    }
  }

  const columnDef = ColumnDefShipmentOutbox(handleAction, isReasonModalOpen);

  const handleCreateShipmentBtnClick = () => {
    navigate('/create-shipment'); // Navigate to create shipment page
  };

  // Handle page size change
  const handlePageIndexChange = (newPageNumber) => {
    setPageNumber(newPageNumber);
    // console.warn('page number :',newPageNumber);
  };

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    // console.warn('page size :',newPageSize);

    setPageNumber(1); // Reset to first page on page size change
  };

  const onCancelModalClose = () => {
    setIsCancelModalOpen(false)
  }

  const onDeleteModalClose = () => {
    setIsDeleteModalOpen(false)
  }

  const handleDelete = () => {
    dispatch(deleteShipmentById(shipmentId)).then(
      () => {
        const queryParams = {
          type: 'outgoing',
          searchText: filters.search || '',
          fromDate: filters.fromDate || '',
          toDate: filters.toDate || '',
          shipmentStatus: filters.shipmentStatus || '',
          pageSize,
          pageNumber,
        };
        dispatch(fetchShipments(queryParams));
      }
    );
  }

  // if (isLoading) return <div>Loading...</div>;
  // if (isError) return <div>Error: {isError}</div>;

  return (
    <>
      <div className="btn-box py-3">
        <div className="d-flex justify-content-between">
          <div>
            <button className="btn btn-primary greeen-btn md_btn" onClick={handleCreateShipmentBtnClick}>
              <span><ControlPointOutlinedIcon /></span> Create New
            </button>
          </div>
          <div>
            <Button
              aria-controls="export-menu"
              aria-haspopup="true"
              onClick={handleClick}
              // variant="contained"
              style={{ backgroundColor: '#6AA13C' }}
              className='btn btn-primary greeen-btn md_btn m-2 h-100'
              startIcon={<FileOutlineIcon />}
            >
              Export
            </Button>
            <Menu
              id="export-menu"
              anchorEl={anchorEl}
              keepMounted
              open={open}
              onClose={handleClose}
            >
              <MenuItem onClick={handleClose}>  <DownloadButton
                data={tableData}
                filename='Outgoing Shipment List.xlsx'
                sheetname='Shipment List'
                forModule='Shipment' /></MenuItem>
            </Menu>
            <button className="btn btn-light grey-btn md_btn me-0" onClick={() => setIsFilterPanelOpen(prevState => !prevState)}>
              <span><i className="bi bi-funnel"><FilterAltOutlinedIcon /></i></span> Filters
            </button>
          </div>
        </div>
      </div>
      {isFilterPanelOpen && <FilterPanelShipment className='mb-3' isShipmentStatus={true} onFilter={handleFilter} onReset={handleReset} />}
      <MainTable
        columns={columnDef}
        data={tableData}
        initialPageSize={pageSize}
        pageNumber={pageNumber}
        onPageIndexChange={onPageIndexChange}
        onPageSizeChange={onPageSizeChange}
        enablePagination={true}
        totalRecords={totalRecords} // Pass the totalRecords to MainTable
        recordCountText="records found"
      />
      {isCancelModalOpen &&
        <DeclineShipmentModalComponent
          isOpen={isCancelModalOpen}
          onClose={onCancelModalClose}
          id={shipmentId}
          forModule='Shipment'
          action={actionType}
        />
      }
      {isDeleteModalOpen &&
        <WarningShipmentModalComponent
          isOpen={isDeleteModalOpen}
          onClose={onDeleteModalClose}
          handleDelete={handleDelete}
        />
      }
      {
        <AddLotForProductWarningModal
          isOpen={isValidateLotModalOpen}
          onClose={onValidateLotModalClose}
          message={message}
        />}
      {isShipmentAlertModalOpen &&
        <AlertShipmentModal
          isOpen={isShipmentAlertModalOpen}
          onClose={onShipmentAlertModalClose}
          handlePlaceShipment={handlePlaceShipment}
        // isLinked={isLinked}
        />}
      {isPoNotFoundModalOpen &&
        <PoNotFoundModal
          isOpen={isPoNotFoundModalOpen}
          onClose={onPoNotFoundModalClose}
          linkAutoGeneratedOrder={linkAutoGeneratedOrder}
        />
      }
    </>
  )
}

export default ShipmentOutboxComponent;
